import React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import WeaveItem from './WeaveItem';
import { show as showToast } from '../toast/toastSlice';
import { copy } from '../../services/util';
import { show as showPrac } from './weavePracSlice';
import { Weave } from '../../models/weave';

function WeaveList() {
  const dispatch = useAppDispatch();  

  const weaves = useAppSelector(state => state.weaveTrainer.weaves);
  const commands = useAppSelector(state => state.weaveTrainer.commands);
  const earth = useAppSelector(state => state.weaveTrainer.earth);
  const air = useAppSelector(state => state.weaveTrainer.air);
  const fire = useAppSelector(state => state.weaveTrainer.fire);
  const water = useAppSelector(state => state.weaveTrainer.water);
  const spirit = useAppSelector(state => state.weaveTrainer.spirit);
  const separator = useAppSelector(state => state.common.separator);

  const fourth = Math.ceil(weaves.length / 4);
  const col1 = weaves.slice(fourth * 0, fourth * 1);
  const col2 = weaves.slice(fourth * 1, fourth * 2);
  const col3 = weaves.slice(fourth * 2, fourth * 3);
  const col4 = weaves.slice(fourth * 3);

  const weaveReqs = [
    { key: 'E', value: earth },
    { key: 'A', value: air },
    { key: 'F', value: fire },
    { key: 'W', value: water },
    { key: 'S', value: spirit }
  ].filter(x => x.value).map(x => x.value + x.key).join(' ');


  const handleCopyClick = (e: React.MouseEvent) => {
    e.preventDefault();    
    const text = separator?.trim() ? commands.split('\n').join(separator) : commands;
    copy(text);
    dispatch(showToast('Copied to clipboard.'));
  }

  const handleViewClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(showPrac());
  }

  const getChild = (weave: Weave) => {
    return (
      <WeaveItem key={weave.id}
        id={weave.id}
        name={weave.name}
        percentStart={weave.percentStart}
        percentTarget={weave.percentTarget}
        percentActual={weave.percentActual}        
        pracsActual={weave.pracsActual}
        percentActual2={weave.percentActual2}
        pracsActual2={weave.pracsActual2}
        earth={weave.earth}
        air={weave.air}
        fire={weave.fire}
        water={weave.water}
        spirit={weave.spirit}
        clanned={weave.clanned}
        busy={weave.busy}
      />
    );
  }

  return (
    <div className="weave-list">
      <div className="group-title">
        <h6 className="me-3 my-0">WEAVES</h6>
        <a className="text-decoration-none" href="/#" onClick={e => handleCopyClick(e)}>Copy</a>
        <div className="small mx-2 text-light">|</div>
        <a className="text-decoration-none" href="/#" onClick={e => handleViewClick(e)}>View</a>
        <div className="ms-auto fw-bold">{weaveReqs}</div>
      </div>
      <div className="row g-0">
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell group-list">
            {col1.map(weave => getChild(weave))}
          </div>
        </div>
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell group-list">
            {col2.map(weave => getChild(weave))}
          </div>
        </div>
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell group-list">
            {col3.map(weave => getChild(weave))}
          </div>
        </div>
        <div className="column col-12 col-md-6 col-xl-3">
          <div className="cell group-list">
            {col4.map(weave => getChild(weave))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(WeaveList);
